import script from "./ScreenShotActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenShotActivity.vue?vue&type=script&setup=true&lang=js"

import "./ScreenShotActivity.vue?vue&type=style&index=0&id=366b9e3a&lang=css"

const __exports__ = script;

export default __exports__